/**
 * ヘッダー領域で始まったポインタ操作を、モーダルのドラッグ開始として扱ってよいか判定する。
 *
 * ヘッダーには閉じるボタンや headerActions が並ぶ。これらの上での押し込みまで
 * ドラッグ開始にすると、タップのつもりの操作がモーダルの移動になる。
 */
const INTERACTIVE_ELEMENT_SELECTOR = [
  "a[href]",
  "button",
  "input",
  "select",
  "textarea",
  "[contenteditable='true']",
  "[role='button']",
  "[role='link']",
  "[role='menuitem']",
  "[role='tab']",
].join(", ");

export function isModalDragHandleTarget(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;
  return target.closest(INTERACTIVE_ELEMENT_SELECTOR) === null;
}
